<template>
    <div>
        <b-alert
            v-model="autoDismissCountDown"
            dismissible
            :variant="alertType == 'success' ? 'success' : 'danger'"
            @dismissed="autoDismissCountDown=0"
            @dismiss-count-down="autoDismissCountDownChanged"
        >
            {{ message }}
        </b-alert>
    </div>
</template>

<script>
export default {
    data() {
        return {
            autoDismissSecs: 3,
            autoDismissCountDown: 0,
            message: '',
            alertType: 'success'
        }
    },
    mounted() {
        window.emitter.on('alertSuccess', (data) => {
            setTimeout(() => {
                this.autoDismissCountDown = data.timer ? data.timer : this.autoDismissSecs;
                this.message = data.message;
                this.alertType = data.alertType ? data.alertType : 'success'
            }, 800)
        })
    },
    methods: {
        autoDismissCountDownChanged(countDown) {
            this.autoDismissCountDown = countDown
        },
        showAutoDismissAlert() {
            this.autoDismissCountDown = this.autoDismissSecs
        }
    }
}
</script>
<style scoped>
    .alert {
        position: fixed;
        /* width: 85%; */
        z-index: 1;
        /* padding-top: 10px; */
        top: 60px;
        right: 10px;
    }
</style>